export const lawFirmNav = [
  {
    id: 'law-firm-header',
    text: 'À propos',
    exist: true,
  },
  {
    id: 'pages-top-decisions',
    text: 'Dernières décisions',
    exist: false,
  },
  {
    id: 'law-firm-offices',
    text: 'Bureaux',
    exist: false,
  },
  {
    id: 'office-lawyers',
    text: 'Avocats',
    exist: false,
  },
  {
    id: 'lawFirm-expertises',
    text: 'Expertises',
    exist: false,
  },
  {
    id: 'lawFirm-clients',
    text: 'Clients',
    exist: false,
  },
];
